export default __webpack_public_path__ + "static/media/BallWithDots.64431db7.svg";